enum UserStatus{
  ACTIVE= 'ACTIVE',
  PENDING= 'PENDING',
  SUSPENDED= 'SUSPENDED'
};
export default UserStatus;